import React from "react"
import {FieldViewSmallProps} from "../../../../render/view-small"

export default function FieldCurrency_ViewSmall(props: FieldViewSmallProps) {

    const value = props.field.getViewValue(props.model)

    if (!value) return null

    const displayValue  = props.field.getDisplayValue(value)
    const currencyId    = (props.field as any).symbolId
    const currencyMark  = currencyId ? gd.const.currency[currencyId]?.symbol : ''

    return (
        <div className="flex-row-left-center p-h-10 ui5-txt-less-important-small">
            {!!currencyMark && <div className="symbol m-r-5">{currencyMark}</div>}
            <div className="max-w-100-percent txt-truncate">{displayValue}</div>
        </div>
    )
}
